import React, { useState } from 'react';
import { useAuth } from '../../../../../../../context/AuthContext';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";
import GeneralRequestHelper from '../../../../../../../Helpers/GeneralRequestHelper';
import SubmitButton from '../UI/SubmitButton';
import InfoInput from '../UI/InfoInput';
import CorrectAnswer from '../UI/CorrectAnswer';
import QuestionTextInput from '../UI/QuestionTextInput';
import AddContentQuestion from '../UI/AddContentQuestion';
import Tag from '../UI/Tag';
import TitleArea from '../UI/TitleArea';
import AnswerFormMatch from '../UI/AnswerFormMatch';

const Match = (props) => {
    const { user } = useAuth();
    const params = useParams()
    const navigate = useNavigate();
    const [msg, setMsg] = useState([]);
    const [imagePath, setImagePath] = useState(null);
    const [videoPath, setVideoPath] = useState(null);
    const [soundPath, setSoundPath] = useState(null);
    const [serviceList, setServiceList] = useState([{ service: "" }]);

    // "auto" = mevcut sistem (boşluk varsa kelime, yoksa harf)
    // "word" = her zaman harf harf
    // "sentence" = her zaman kelime kelime
    // "mixed" = kelime kelime + token içindeki -/_ ayrıştır (volume_up => volume + up)
    const [splitMode, setSplitMode] = useState("auto");

    const tokenize = (rawInput, mode) => {
        const s = (rawInput ?? "").trim();
        if (!s) return [];
        if (mode === "mixed") {
            // Cümle gibi önce boşlukla ayır, sonra token içindeki -/_ parçala
            const bySpace = s.split(/\s+/).filter(Boolean);
            return bySpace.flatMap(t => t.split(/[-_]+/).filter(Boolean));
        }

        // auto (mevcut davranış)
        if (s.includes(" ")) return s.split(/\s+/).filter(Boolean);
        return s.split("");
    };

    const handletype3 = async (e) => {
        e.preventDefault();
        if (document.getElementById("tagId").value === "Tür Seçiniz") {
            alert("Tür Seçmediniz.")
            return false;
        }

        var answer = document.getElementById("correctAnswer").value;
        var detailAnswer = [];

        const rawInput = document.getElementById("correctAnswer").value;
        let parsedArray = tokenize(rawInput, splitMode);
        alert(splitMode)
        // Shuffle
        for (let i = parsedArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [parsedArray[i], parsedArray[j]] = [parsedArray[j], parsedArray[i]];
        }

        for (let i = 0; i < parsedArray.length; i++) {
            let answerItem = {
                id: i,
                service: parsedArray[i],
            };
            detailAnswer.push(answerItem);
        }

        var splittedanswerjs = JSON.stringify(detailAnswer);

        var question;
        let questiontext = document.getElementById("questionText").value.trim() || " ";

        if (imagePath && soundPath) {
            question = {
                type: "image_sound",
                url: imagePath,
                soundUrl: soundPath,
                text: questiontext,
                mode: splitMode
            };
        }
        else if (imagePath) {
            question = {
                type: "image",
                url: imagePath,
                text: questiontext,
                mode: splitMode
            };
        }
        else if (soundPath) {
            question = {
                type: "sound",
                url: soundPath,
                text: questiontext,
                mode: splitMode
            };
        }
        else if (videoPath) {
            question = {
                type: "video",
                url: videoPath,
                text: questiontext,
                mode: splitMode
            };
        }
        else {
            question = {
                type: "text",
                url: "",
                text: questiontext,
                mode: splitMode
            };
        }

        var stringquestion = JSON.stringify(question)
        var info = document.getElementById("infoBoxText").value;

        try {
            const data = {
                isDeleted: false,
                tagId: document.getElementById("tagId").value,
                sortId: params["sort"],
                contentType: "match",
                subjectId: params["subject"],
                contentStr: stringquestion,
                detail: splittedanswerjs,
                notfyText: info,
                answer: answer
            };

            await GeneralRequestHelper("/api/admin/ContentManager/Create", "post", data, user.token).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Soru ekleme sayfasına Dön`,
                            showDenyButton: true,
                            denyButtonText: `Aynı konuya bir soru daha ekle`,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/admin/createquestion");
                            } else if (result.isDenied) {
                                navigate("/admin/createquestionbysubject/" + params["subject"]);
                            }
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message)
            setMsg(err.message);
        }
    }

    return (
        <div>
            <TitleArea msg={msg} text={"UNSCREABLE - harflerden kelime/kelimelerden cümle"} />
            <Tag />
            <AddContentQuestion
                setMsg={setMsg}
                setImagePath={setImagePath}
                setVideoPath={setVideoPath}
                setSoundPath={setSoundPath}
                imagePath={imagePath}
                videoPath={videoPath}
                soundPath={soundPath}
            />
            <hr />
            <form onSubmit={handletype3} >
                <QuestionTextInput />

                <div style={{ margin: "12px 0" }}>
                    <label style={{ display: "block", marginBottom: 6 }}>Parçalama türü</label>
                    <select
                        value={splitMode}
                        onChange={(e) => setSplitMode(e.target.value)}
                        style={{ padding: 8, width: "100%" }}
                    >
                        <option value="auto">Otomatik Eski Sistemde ki gibi!</option>
                        <option value="mixed">Karışık (volume up gibi )</option>
                    </select>
                </div>

                <CorrectAnswer text="Lütfen büyük harfler ile yazınız. Kelimeyi veya cümleyi olduğu gibi yazınız! Seçtiğiniz parçalama türüne göre sistem otomatik olarak parçalayacaktır." />
                <InfoInput />
                <SubmitButton />
            </form>
            <hr />
        </div>
    );
};

export default Match;